import { render, staticRenderFns } from "./ACategorias.vue?vue&type=template&id=67e85d46"
import script from "./ACategorias.vue?vue&type=script&lang=js"
export * from "./ACategorias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports